var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSms24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M18666.014-6235a8.011,8.011,0,0,1-4.125-1.138l-3.271,1.083a.455.455,0,0,1-.15.025.473.473,0,0,1-.375-.193.46.46,0,0,1-.07-.414l1.041-3.375a8.058,8.058,0,0,1-1-4.972,7.927,7.927,0,0,1,2.283-4.673A7.964,7.964,0,0,1,18666-6251a7.953,7.953,0,0,1,5.656,2.344A7.949,7.949,0,0,1,18674-6243a7.949,7.949,0,0,1-2.344,5.657A7.934,7.934,0,0,1,18666.014-6235Zm2.99-9a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0,18669-6244Zm-3,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0,18666-6244Zm-3,0a1.006,1.006,0,0,0-1.008,1,1,1,0,0,0,1.008,1,1,1,0,0,0,.994-1A1,1,0,0,0,18663-6244Z",
    transform: "translate(-18658 6251)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSms24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_sms24x24.9ede79ef55b600402bd8e539d195fe23.svg";